// Style
import '../../styles/main/projects.scss'

// Components
import Folder from './folder'
import Project from './project'

// Language
import { useLanguage } from '../../context/language_context'


function FolderWindow({
    folder,
    path = [],
    onOpenFolder,
    onOpenProject,
    onClose,
    isRoot = false
}) {

    const { language } = useLanguage()

    const children = folder.children || []


    // ========================================
    // TRANSLATION
    // ========================================

    const translate = (value) => {

        // Anciennes valeurs qui sont encore de simples strings
        if (typeof value === 'string') {
            return value
        }

        // Nouvelles valeurs bilingues { fr, en }
        if (value && typeof value === 'object') {
            return value[language] || value.fr || ''
        }

        return ''
    }


    // ========================================
    // PATH
    // ========================================

    const currentPath = [
        'C:',
        'Maurine_Duet',
        language === 'en' ? 'Projects' : 'Projets',
        ...path.map((item) => translate(item))
    ].join('/')


    return (

        <div className={`projects ${isRoot ? 'root_projects' : 'folder_window'}`}>

            {/* HEADER */}

            <div className="projects_title">

                {/* BARRE BLEUE */}

                <div className="projects_title_up">

                    <h3>{currentPath}</h3>

                    {!isRoot && (
                        <p
                            className="close_button"
                            onClick={onClose}
                        >
                            X
                        </p>
                    )}

                </div>


                {/* MENU */}

                <nav>
                    <ul>
                        <li>File</li>
                        <li>Edit</li>
                        <li>View</li>
                        <li>Help</li>
                    </ul>
                </nav>

            </div>


            {/* CONTENU */}

            <div className="projects_main">

                {children.map((item) => {

                    if (item.type === 'folder') {

                        const translatedName = translate(item.name)

                        return (
                            <Folder
                                key={item.id}
                                name={translatedName}
                                onOpen={() =>
                                    onOpenFolder(
                                        item,
                                        [...path, item.name]
                                    )
                                }
                            />
                        )

                    }

                    if (item.type === 'project') {

                        return (
                            <Project
                                key={item.id}
                                name={translate(item.name)}
                                onOpen={() => onOpenProject(item)}
                                isMainPage={isRoot}
                            />
                        )

                    }

                    return null

                })}

            </div>


            {/* FOOTER */}

            <div className="projects_footer">

                {language === 'en' ? (

                    <p>
                        {children.length} item{children.length > 1 ? 's' : ''}
                    </p>

                ) : (

                    <p>
                        {children.length} élément{children.length > 1 ? 's' : ''}
                    </p>

                )}

            </div>

        </div>
    )
}

export default FolderWindow